import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  addMasterCurriculumAsync,
  getAllMasterCurriculumAsync,
  getMasterCurriculumByIdAsync,
  updateMasterCurriculumByIdAsync,
  updateMasterCurriculumStatusAsync,
} from "./mastercurriculum.async";

const initialState = {
  masterCurriculumLoader: false,
  getAllMasterCurriculum: [],
  masterCurriculumAdd: [],
  masterCurriculumById: [],
  masterCurriculumUpdate: [],
  masterCurriculumStatus: [],
};

export const masterCurriculumSlice = createSlice({
  name: "Spoken English",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        getAllMasterCurriculumAsync.pending,
        addMasterCurriculumAsync.pending,
        updateMasterCurriculumByIdAsync.pending,
        getMasterCurriculumByIdAsync.pending,
        updateMasterCurriculumStatusAsync.pending
      ),
      (state) => {
        state.masterCurriculumLoader = true;
      }
    );
    builder.addMatcher(
      isAnyOf(getAllMasterCurriculumAsync.fulfilled),
      (state, action) => {
        state.masterCurriculumLoader = false;
        state.getAllMasterCurriculum = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(addMasterCurriculumAsync.fulfilled),
      (state, action) => {
        state.masterCurriculumLoader = false;
        state.masterCurriculumAdd = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(getMasterCurriculumByIdAsync.fulfilled),
      (state, action) => {
        state.masterCurriculumLoader = false;
        state.masterCurriculumById = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(updateMasterCurriculumByIdAsync.fulfilled),
      (state, action) => {
        state.masterCurriculumLoader = false;
        state.masterCurriculumUpdate = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(updateMasterCurriculumStatusAsync.fulfilled),
      (state, action) => {
        state.masterCurriculumLoader = false;
        state.masterCurriculumStatus = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getAllMasterCurriculumAsync.rejected,
        addMasterCurriculumAsync.rejected,
        updateMasterCurriculumByIdAsync.rejected,
        getMasterCurriculumByIdAsync.rejected,
        updateMasterCurriculumStatusAsync.rejected
      ),
      (state, action) => {
        state.masterCurriculumLoader = false;
      }
    );
  },
  reducers: {
    emptyMasterCurriculum: () => initialState,
  },
});

export const { emptyMasterCurriculum } = masterCurriculumSlice.actions;

export default masterCurriculumSlice.reducer;
